import { render } from "./TransitionScreen.vue?vue&type=template&id=25ac2154"
import script from "./TransitionScreen.vue?vue&type=script&lang=js"
export * from "./TransitionScreen.vue?vue&type=script&lang=js"

import "./TransitionScreen.vue?vue&type=style&index=0&id=25ac2154&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__